import { AUDIT_LOG_PAGE_INTRO } from "../auditLogPage.constants";

export function AuditLogIntro() {
  return <p className="mb-6 text-sm text-muted-foreground">{AUDIT_LOG_PAGE_INTRO}</p>;
}
